import { SignInResponseType } from '../../../services/session/ISessionService';
import SessionInterfaceV1 from './SessionInterfaceV1';
import { SessionInterfaceV1Type } from '@clientos/types';
import { internalLogger } from '../clientOsLogger';

let sessionInterfaceV1: SessionInterfaceV1;

export function getSessionInterfaceV1(): SessionInterfaceV1Type {
  return sessionInterfaceV1.getInterface();
}

export default async function initializeSessionInterfaceV1(): Promise<SessionInterfaceV1Type> {
  if (sessionInterfaceV1) return sessionInterfaceV1.getInterface();
  sessionInterfaceV1 = new SessionInterfaceV1();

  return sessionInterfaceV1.getInterface();
}

export function createNoopSessionInterfaceInterface(): SessionInterfaceV1Type {
  return {
    isLoggedIn: function (): boolean {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopSessionInterfaceInterface',
        methodName: 'isLoggedIn()',
        message: 'Noop interface method called - returning false'
      });
      return false;
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getProviderList: function (): Promise<any> {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopSessionInterfaceInterface',
        methodName: 'getProviderList()',
        message: 'Noop interface method called - returning resolved promise'
      });
      return Promise.resolve();
    },
    generateAuthenticationUrl: function (): Promise<string> {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopSessionInterfaceInterface',
        methodName: 'generateAuthenticationUrl()',
        message: 'Noop interface method called - returning empty string'
      });
      return Promise.resolve('');
    },
    logout: function (): Promise<void> {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopSessionInterfaceInterface',
        methodName: 'logout()',
        message: 'Noop interface method called - returning resolved promise'
      });
      return Promise.resolve();
    },
    refreshToken: function (): Promise<void> {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopSessionInterfaceInterface',
        methodName: 'refreshToken()',
        message: 'Noop interface method called - returning resolved promise'
      });
      return Promise.resolve();
    },
    getIdToken: function (): string {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopSessionInterfaceInterface',
        methodName: 'getIdToken()',
        message: 'Noop interface method called - returning empty string'
      });
      return '';
    },
    signIn: function (): Promise<SignInResponseType> {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopSessionInterfaceInterface',
        methodName: 'signIn()',
        message: 'Noop interface method called - returning success response'
      });
      return Promise.resolve({ success: true });
    },
    isLoggedInWithTenant: function (): boolean {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopSessionInterfaceInterface',
        methodName: 'isLoggedInWithTenant()',
        message: 'Noop interface method called - returning false'
      });
      return false;
    }
  };
}
